module.exports = __webpack_public_path__ + "img/rvdsb-1@2x.e277f324.png";